import type { ContainerLevelHistory } from "@ots-frontend/ots-data";
import type { OtsTimeSeries } from "../components/OtsTimeSeriesChart";

export type ContainerLevelMeasure = "volume" | "level";

/** Where a reading came from, in a fixed order so each source keeps its color: SCADA, then driver and field gauging. */
export const CONTAINER_LEVEL_SOURCES = [
  { type: "Meter", label: "SCADA" },
  { type: "Driver Entered", label: "Driver gauging" },
  { type: "Field Entered", label: "Field gauging" },
] as const;

/** Readings as one line per source, oldest first; readings without the measure are left out. */
export const containerLevelSeries = (levels: ContainerLevelHistory[], measure: ContainerLevelMeasure): OtsTimeSeries[] =>
  CONTAINER_LEVEL_SOURCES.map(({ type, label }, slot) => ({
    id: type,
    label,
    slot,
    // Gaugings are spot readings; only SCADA reads often enough to draw as a line.
    style: type === "Meter" ? "line" as const : "points" as const,
    points: levels
      .filter((reading) => reading.type === type && reading[measure] != null)
      .map((reading) => ({ time: reading.createDttm, value: reading[measure]! }))
      .sort((left, right) => left.time - right.time),
  })).filter((series) => series.points.length > 0);

/** The source's name for a reading's type. */
export const containerLevelSourceLabel = (type: string) =>
  CONTAINER_LEVEL_SOURCES.find((source) => source.type === type)?.label ?? type;
